import * as React from 'react';

/**
 * Component avoid rendering noscript content on client as react actually create nodes and causes images to load
 */
class NoScript extends React.PureComponent {
  render() {
    const isSSR = typeof window === 'undefined' || navigator.userAgent.includes('jsdom');
    return (
      <noscript>
        {isSSR ? this.props.children : null }
      </noscript>
    );
  }
}

export default NoScript;
